<div class="user-header-container">
  <mat-toolbar class="header-color" *ngIf="headerDto">
    <div class="header-content">
      <div class="header-content-left">
        <div
          *ngIf="headerDto.isRoom; else isUser"
          class="header-photo-icon-canais"
        >
          <span class="material-icons icon-business"> business </span>
        </div>
        <ng-template #isUser>
          <img class="header-photo" src="{{ headerDto.photo }}" />
        </ng-template>
      </div>
      <div class="header-content-right" *ngIf="headerDto.alias">
        <span class="header-profile">
          {{ headerDto.profile }}
        </span>
        <span class="header-name">
          {{ headerDto.name }}
        </span>
        <span class="header-alias">
          {{ headerDto.alias }}
        </span>
        <div class="show-details" (click)="showUserDetails()">
          <span class="show-details-text">
            {{ detailsText }}
          </span>
        </div>
      </div>
      <div class="header-content-right" *ngIf="!headerDto.alias">
        <span class="header-profile">
          {{ headerDto.profile }}
        </span>
        <span class="header-alias">
          {{ headerDto.name }}
        </span>
        <div class="show-details" (click)="showUserDetails()">
          <span class="show-details-text">
            {{ detailsText }}
          </span>
        </div>
      </div>
      <div class="ticket-container" *ngIf="ticket">
        <span>
          Atendimento: 
            <span
              [ngClass]="getTicketStatus(true)"
            >
              {{getTicketStatus(false)}}
            </span>
        </span>
      </div>
    </div>
  </mat-toolbar>
</div>
